module.exports = __webpack_public_path__ + "html/document-wrap.template.html";